<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <div>
          <h1 class="title has-text-centered">500</h1>
          <h2 class="subtitle has-text-centered">
            The page you're looking for could not be loaded now please try again
            later.
          </h2>
          <h2 class="subtitle has-text-centered">
            <a href="javascript:history.go(-1)">Go back</a>
          </h2>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
